import { render, staticRenderFns } from "./DocumentItemCard.vue?vue&type=template&id=0a6c7a2b&scoped=true"
import script from "./DocumentItemCard.vue?vue&type=script&lang=js"
export * from "./DocumentItemCard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a6c7a2b",
  null
  
)

export default component.exports